import get from 'lodash.get';

import { RESET_STATE } from 'services/auth/constants';
import { SCAFFOLD_DATA_LOAD_SUCCEEDED } from 'services/scaffoldData/constants';
import { ProductTypeState, ProductTypesActions } from './types';

const initialState: ProductTypeState = [];

export default function (
    state: ProductTypeState = initialState,
    action: ProductTypesActions
): ProductTypeState {
    switch (action.type) {
        case SCAFFOLD_DATA_LOAD_SUCCEEDED:
            return get(action, 'response.productTypes', []);
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
